import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource, MatSort, MatPaginator } from '../../../../../../node_modules/@angular/material';
import { PlanterService } from '../../../../services/planter/planter.service';
import { PlantersReport } from "../../../../models/planters-report.model";
import { District } from '../../../../models/district.model';
import { Sectional } from '../../../../models/sectional.model';
import { Church } from '../../../../models/church.model';
import { FormControl } from '../../../../../../node_modules/@angular/forms';
import { RegistrationService } from '../../../../services/registration/registration.service';
import { LoadService } from '../../../../components/loader/loader.service';

@Component({
  selector: 'app-planters-report',
  templateUrl: './planters-report.component.html',
  styleUrls: ['./planters-report.component.scss']
})
export class PlantersReportComponent implements OnInit {
  
  loader: any
  isAuthorized = true;
  allReports: PlantersReport[] = [];

  ctrlSectional: FormControl
  ctrlChurch: FormControl

  districts: District[] = [];
  sectionals: Sectional[] = [];
  churches: Church[] = [];

  districtValue: string;
  sectionalValue: string;
  churchValue: string;

  totalConversion: number = 0;
  totalDiscipled: number = 0;
  totalBaptism: number = 0;
  totalGroupAsist: number = 0;
  totalLeaders: number = 0;
  totalSmallGroups: number = 0;

  totalsReport = []

  displayedColumns = ['name', 'conversion', 'discipled', 'baptism', 'groupAsist', 'leaders', 'smallGroups'];
  dataSource = new MatTableDataSource(this.allReports);

  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  constructor(private planterService: PlanterService,
              private registrationService: RegistrationService,
              private loadService: LoadService) { 

        this.loader = this.loadService.createLoad('');
        this.loader.open()
        this.registrationService.getDistricts().subscribe((districts: District[]) => {
          this.districts = districts;
          this.loader.close()
        });
        
        this.loadReports();
        this.loadTotals();
        
        this.ctrlSectional = new FormControl({value: '', disabled: true}, [])
        this.ctrlChurch = new FormControl({value: '', disabled: true}, []);
  }

  ngOnInit() {
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  loadReports() {
    this.planterService.getPlanterReports().subscribe(
      (data: PlantersReport[]) => {
        this.allReports = data;

        this.dataSource = new MatTableDataSource(this.allReports);
        this.calculateTotals(this.allReports)

        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      },
      (error) => {
        console.log('error',error)
        this.isAuthorized = false
      })
  }

  applyDistrictFilter(district: District) {
    this.dataSource.filter = district.name;
    this.registrationService.getDistrictDataById(district.id).subscribe((sectionalsData) => {
      this.sectionals = sectionalsData['sectionals']
    });
    this.ctrlSectional.enable();
    this.ctrlChurch.setValue('');
    this.ctrlChurch.disable();

    this.calculateTotals(this.dataSource.filteredData)
  }

  applySectionalFilter(sectional: Sectional) {
    this.dataSource.filter = sectional.name;
    this.loadChurchData(sectional)
    this.ctrlChurch.enable();

    this.calculateTotals(this.dataSource.filteredData)
  }

  loadChurchData(sectional) {
    if(sectional.id > 0) {
      this.churches = []
      const cities = sectional.cities
      cities.forEach(city => {
        const churches = city.churches
        churches.forEach(ch => {
            let church = new Church
            church.id = ch.id
            church.name = ch.name
            this.churches.push(church)
        });
      });
    }
  }

  applyChurchFilter(church: Church) {
    this.dataSource.filter = church.name;
    this.calculateTotals(this.dataSource.filteredData)
  }

  clearFilters() {
    this.dataSource.filter = "";
    this.districtValue = "";
    this.sectionalValue = "";
    this.churchValue = "";
    
    this.dataSource.filter = "";
    this.calculateTotals(this.dataSource.filteredData)
  }

  calculateTotals(reports) {
    this.totalConversion = 0;
    this.totalDiscipled = 0;
    this.totalBaptism = 0;
    this.totalGroupAsist = 0;
    this.totalLeaders = 0;
    this.totalSmallGroups = 0;
    
    reports.forEach(data => { 
      this.totalConversion += data.report.total_conversions;
      this.totalDiscipled += data.report.total_discipled;
      this.totalBaptism += data.report.total_baptism;
      this.totalGroupAsist += data.report.weekly_attendees;
      this.totalLeaders += data.report.total_leaders;
      this.totalSmallGroups += data.report.total_small_groups;
    });

    this.loadTotals()
  }

  loadTotals() {
    this.totalsReport = [
      {
        title: "Total conversiones",
        value: this.totalConversion
      },
      {
        title: "Total discipulado",
        value: this.totalDiscipled
      },
      {
        title: "Bautizo",
        value: this.totalBaptism
      },
      {
        title: "Asistentes en grupo",
        value: this.totalGroupAsist
      },
      {
        title: "Lideres en formación",
        value: this.totalLeaders
      },
      {
        title: "Grupos pequeños",
        value: this.totalSmallGroups
      }
    ]
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/pages/extension/planters-report/planters-report.component.ts